import { forwardRef, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface Props {
  children: ReactNode;
  className?: string;
}

const PageContent = forwardRef<HTMLElement, Props>(
  ({ children, className }, ref) => {
    return (
      <main
        ref={ref}
        className={twMerge(
          "relative flex min-h-0 flex-1 flex-col overflow-hidden px-8 py-5.5",
          className,
        )}
      >
        {children}
      </main>
    );
  },
);

PageContent.displayName = "PageContent";

export default PageContent;
